import React from 'react';
import Button from './Button';
import './HeroSection.css';

const HeroSection: React.FC = () => {
  return (
    <section className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-title">
            One App.<br />
            <span className="hero-title-green">Instant Money.</span><br />
            Full Control.
          </h1>
          <p className="hero-description">
            Finally, payments caught up. Pagarva unifies payments, money management, 
            and bookkeeping in one simple app. That's all you need.
          </p>
          <Button variant="primary" href="/download/" trackingLabel="Download" trackingLocation="hero">Download</Button>
        </div>
        <div className="hero-image">
          <video src="/assets-project/videos/heeero_2.mp4" autoPlay muted loop playsInline aria-label="Pagarva Mobile App" />
        </div>
      </div>
      <div className="hero-line"></div>
    </section>
  );
};

export default HeroSection;